import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { NAV, BRAND, LOGO } from "../data/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 border-b ${
        scrolled ? "bg-[#09090b]/90 backdrop-blur-xl border-white/5" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img src={LOGO} alt="BarManProf logo" className="h-11 w-11 object-contain group-hover:scale-105 transition-transform" />
          <span className="font-display text-2xl font-bold tracking-tight">
            BarMan<span className="text-[#D97736]">Prof</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors hover:text-[#D97736] ${
                  isActive ? "text-[#D97736]" : "text-[#A1A1AA]"
                }`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
          <Link
            to="/contatti"
            data-testid="nav-cta-button"
            className="bg-[#D97736] text-white px-6 py-2.5 rounded-sm text-sm font-semibold tracking-wide hover:bg-[#B85B22] transition-all shadow-[0_0_20px_rgba(217,119,54,0.25)]"
          >
            Prenota una call
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={28} /> : <List size={28} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#09090b]/98 backdrop-blur-xl border-t border-white/5 px-6 py-6 flex flex-col gap-4">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) => `text-base py-1 ${isActive ? "text-[#D97736]" : "text-[#F8F8F8]"}`}
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
          <Link
            to="/contatti"
            data-testid="mobile-nav-cta"
            className="bg-[#D97736] text-white px-6 py-3 rounded-sm text-center font-semibold mt-2"
          >
            Prenota una call
          </Link>
        </div>
      )}
    </header>
  );
};
